import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

// The one place tooltips are built: a second instance on the same element
// stacks a second tip that nothing hides. `data-bs-*` attributes still apply.
// With `data-bs-selector`, Bootstrap builds one tooltip per matching child on
// hover: those are disposed here too, or a tip shown when the frame is replaced
// (click on a slot of the availabilities grid) stays on the page for good.
export default class extends Controller {
  connect () {
    this.dispose()
    new Tooltip(this.element, { placement: this.element.dataset.bsPlacement || "bottom" })
  }

  disconnect () {
    this.dispose()
  }

  dispose () {
    const selector = this.element.dataset.bsSelector
    const elements = selector ? [this.element, ...this.element.querySelectorAll(selector)] : [this.element]

    elements.forEach((element) => {
      try {
        Tooltip.getInstance(element)?.dispose()
      } catch (error) {
        // Element may have already been removed from DOM by Turbo Stream
      }
    })
  }
}
